/* eslint-disable react/display-name */
/* eslint-disable @next/next/no-img-element */
import SinglePersonStyles from '../../../styles/elements/people/SinglePersonStyles.module.scss';
import { PortableText, urlFor } from '../../../lib/sanity';

const serializers = {
  marks: {
    link: ({ children, mark }) =>
      mark.blank ? (
        <a href={mark.href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={mark.href}>{children}</a>
      )
  }
};

const SinglePersonDisplay = ({ person }) => {
  return (
    <div className="container">
      <div className={SinglePersonStyles.profile}>
        <div className="profilepic">
          <img src={urlFor(person?.image).auto('format').width(600).height(500).url()} alt={person?.image?.alt} className={SinglePersonStyles.profileimg} />
        </div>
        <div className="bio">
          <div className="copyentry">
            <h1 className={SinglePersonStyles.h1}>{person.name}</h1>
            <h4 className={SinglePersonStyles.h1}>
              <i>{person?.position}</i>
            </h4>
            <PortableText blocks={person?.bio} className="portable-text" serializers={serializers} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePersonDisplay;
